import styled, { keyframes } from 'styled-components'
import { SpinnerProps } from '.'

const rotate360 = keyframes`
0% {  
  transform: rotate(0deg);
}
100% {
  transform: rotate(359deg);
}
`

export const SpinnerWrapper = styled.svg.attrs<SpinnerProps>(({ size }) => ({
  viewBox: `0 0 ${size} ${size}`,
  xmlns: 'http://www.w3.org/2000/svg',
}))<SpinnerProps>`
  fill: inherit;
  color: inherit;
  animation: ${rotate360 as any} 1.75s infinite linear;
  width: ${props => props.size}px;
  height: ${props => props.size}px;
`

SpinnerWrapper.defaultProps = {
  size: 48,
}



// WEBPACK FOOTER //
// ./src/components/Spinner/SpinnerWrapper.tsx